import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'
import { responsiveImageFragment } from '../fragments/images'

export const partnerPage = gql`
  ${seoFragment}
  ${responsiveImageFragment}
  query PartnerPage($locale: SiteLocale) {
    partner(locale: $locale) {
      seo {
        ...SeoFragment
      }
      _allSlugLocales {
        value
        locale
      }
      titolo
      slug
      titoloIntroPartner
      listaIntro {
        titolo
        testo
        immagine {
          responsiveImage {
            src
          }
        }
      }
      bloccoSovrapposto {
        testoDestra
        immagineSinistra {
          responsiveImage(imgixParams: { fm: webp, q: "50" }) {
            ...ResponsiveImageFragment
          }
        }
      }
    }
    azienda(locale: $locale) {
      caroselloClienti {
        titolo
        clienteSlide {
          nome
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
          descrizione
        }
      }
    }
  }
`
